import { render, staticRenderFns } from "./identifier-input.pug?vue&type=template&id=01f1ebca&scoped=true&lang=pug&external"
import script from "./identifier-input.js?vue&type=script&lang=js&external"
export * from "./identifier-input.js?vue&type=script&lang=js&external"
import style0 from "./identifier-input.scss?vue&type=style&index=0&id=01f1ebca&prod&scoped=true&lang=scss&external"
import style1 from "../netbank-common/netbank-common.scss?vue&type=style&index=1&id=01f1ebca&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1ebca",
  null
  
)

export default component.exports